import { AppReloadViewComponent } from '@addins/app-reload/src/app-reload-view/app-reload-view.component';
import { Injectable } from '@angular/core';
import { MenuEntry } from '@services/menu/entry.schema';
import { SideMenuService } from '@services/menu/side-menu.service';
import { AddinExecute, Execute } from '@techwan/ionic-core';

@AddinExecute({
  name: 'AppReloadSetup'
})
@Injectable({
  providedIn: 'root'
})
export class AppReloadSetupService extends Execute {
  private appReloadMenuEntry: MenuEntry = null;

  constructor(private sideMenu: SideMenuService) {
    super();
  }

  execute() {
    this.appReloadMenuEntry = new MenuEntry('AppReload', 'sync', AppReloadViewComponent, -3);
    this.sideMenu.addMenuEntry(this.appReloadMenuEntry);
  }
}
